'use strict';
define(['./links/cookieService'], function (cookieService) {

    function Authentication () {
    }

    Authentication.prototype = {
        isAuthenticated : function () {
            return this.getCookieValue() !== null;
        },

        getCookieValue : function () {
            var cookieValue = cookieService.getUserLoginCookieValue();

            if (cookieValue) {
                cookieValue = decodeURIComponent(cookieValue);
            }

            return cookieValue;
        }
    };

    return Authentication;
});


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/Authentication.js